module.exports = __webpack_public_path__ + "static/media/SOLID.0a6c8a24.svg";